// import React, { useState } from "react";
// import ReactLoading from "react-loading";
// import Select from "react-select";
// import { useTranslation } from "react-i18next";
// import { AbstructVar } from "./AbstructVar";

// function MedicalRepsReportsSelect({
//   testarr,
//   selectedOptions,
//   setSelectedOptions,
//   typeCss,
//   funb,
//   load,
//   is_width,
//   setSelectedIds,
//   selectedIds,
// }) {
//   let { t } = useTranslation();

//   // const toggleOption = (option) => {
//   //   const selectedOptionIds = selectedOptions.map((opt) => opt.id);
//   //   if (selectedOptionIds.includes(option.id)) {
//   //     setSelectedOptions(selectedOptions.filter((opt) => opt.id !== option.id));
//   //   } else {
//   //     setSelectedOptions([...selectedOptions, option]);
//   //   }
//   // };
//   let { langmiamed } = AbstructVar();
//   const customStyles = {
//     control: (provided) => ({
//       ...provided,
//       borderRadius: "8px",
//       borderColor: "#ccc",
//       boxShadow: "none",
//       fontSize:'13px !important'
//     }),
//     placeholder: (provided) => ({
//       ...provided,
//       color: "gray",
//       textAlign: langmiamed === "ar" ? "right" : "left",
//       fontFamily: "GE SS TWO",
//       fontSize:'13px !important'
//     }),
//     multiValue: (provided) => ({
//       ...provided,
//       backgroundColor: "#f0f0f0",
//       borderRadius: "4px",
//       padding: "2px 4px",
//     }),
//     option: (provided, state) => ({
//       ...provided,
//       fontSize:'13px !important',

//       fontFamily: "GE SS TWO",
//     }),
//   };
//   const options = testarr.map((option) => ({
//     value: option.id,
//     label: option.name,
//   }));

//   return (
//     <div className="select-holder">
//       <Select
//         options={options}
//         isMulti
//         value={selectedOptions}
//         onChange={(selectedValues) => {
//           const selectedIds = selectedValues.map((value) => value.value);
//           setSelectedIds(selectedIds);
//           setSelectedOptions(selectedValues);
//         }}
//         placeholder={t("Select a Medical Representative")}
//         styles={{
//           placeholder: (provided) => ({
//             ...provided,
//             color: "gray",
//             textAlign: langmiamed === "ar" ? "right" : "left",
//             fontFamily: "Open Sans, sans-serif",
//           }),
//           menu: (provided) => ({
//             ...provided,
//             textAlign: langmiamed === "ar" ? "right" : "left",
//           }),
//           control: (provided) => ({
//             ...provided,
//             fontFamily: "Open Sans, sans-serif",
//             fontSize:'13px !important'
//           }),
//           option: (provided, state) => ({
//             ...provided,
//             fontSize:'13px !important',
      
//             fontFamily: "GE SS TWO",
//           }),
//         }}
//       />

//       {/* {open && (
//         <div className="select_creatable">
//           {load === false ? (
//             testarr.map((option) => (
//               <div key={option.id} className="lable_multi">
//                 <input
//                   type="checkbox"
//                   checked={selectedOptions.some((opt) => opt.id === option.id)}
//                   onChange={() => toggleOption(option)}
//                 />
//                 <span>{option.name}</span>
//               </div>
//             ))
//           ) : (
//             <div className="loadinselect">
//               <ReactLoading
//                 type="spinningBubbles"
//                 color="#9699c2"
//                 height={"7%"}
//                 width={"7%"}
//               />
//             </div>
//           )}
//         </div>
//       )} */}
//     </div>
//   );
// }

// export default MedicalRepsReportsSelect;



import React from "react";
import ReactLoading from "react-loading";
import Select, { components } from "react-select";
import { useTranslation } from "react-i18next";
import { AbstructVar } from "./AbstructVar";

// Custom Option component to include a checkbox before the label
const CheckboxOption = ({ children, ...props }) => {
  return (
    <components.Option {...props}>
      <input
        type="checkbox"
        checked={props.isSelected}
        onChange={() => null}
        style={{ marginRight: 8, marginLeft: 4 }}
      />
      {children}
    </components.Option>
  );
};

function MedicalRepsReportsSelect({
  testarr,
  selectedOptions,
  setSelectedOptions,
  typeCss,
  funb,
  load,
  is_width,
  setSelectedIds,
  selectedIds,
}) {
  let { t } = useTranslation();
  let { langmiamed } = AbstructVar();
  const isRtl = langmiamed === "ar";

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      borderRadius: "8px",
      borderColor: state.isFocused ? "var(--main-color, #9699c2)" : "#b8c0cc",
      boxShadow: state.isFocused
        ? "0 0 0 2px rgba(150, 153, 194, 0.25)"
        : "none",
      fontSize: "13px",
      minHeight: 42,
      cursor: "text",
    }),
    valueContainer: (provided) => ({
      ...provided,
      flexWrap: "wrap",
      padding: "4px 8px",
      gap: 4,
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#6b7a8d",
      textAlign: isRtl ? "right" : "left",
      fontFamily: "GE SS TWO",
      fontSize: "13px",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      maxWidth: "100%",
    }),
    input: (provided) => ({
      ...provided,
      margin: 0,
      padding: 0,
      color: "#1b262c",
      minWidth: 80,
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: "#eef1f7",
      borderRadius: "4px",
      padding: "1px 2px",
    }),
    option: (provided) => ({
      ...provided,
      fontSize: "13px",
      fontFamily: "GE SS TWO",
      textAlign: isRtl ? "right" : "left",
    }),
    menu: (provided) => ({
      ...provided,
      textAlign: isRtl ? "right" : "left",
      zIndex: 20,
    }),
  };

  const options = (testarr || []).map((option) => ({
    value: option.id,
    label: option.name,
  }));

  const filterOption = (option, rawInput) => {
    const q = (rawInput || "").trim().toLowerCase();
    if (!q) return true;
    const label = String(option?.label ?? "").toLowerCase();
    return label.includes(q);
  };

  const searchPlaceholder =
    t("search_medical_rep") ||
    t("Select a medical representative") ||
    t("Select a Medical Representative");

  return (
    <div className="select-holder medical-reps-select">
      <Select
        options={options}
        isMulti
        value={selectedOptions}
        onChange={(selectedValues) => {
          const values = selectedValues || [];
          setSelectedIds(values.map((value) => value.value));
          setSelectedOptions(values);
        }}
        placeholder={searchPlaceholder}
        closeMenuOnSelect={false}
        hideSelectedOptions={false}
        components={{ Option: CheckboxOption }}
        isSearchable
        filterOption={filterOption}
        noOptionsMessage={() => t("no_data") || t("NoData") || "—"}
        styles={customStyles}
      />
      <p
        className="medical-reps-select__hint"
        style={{
          margin: "6px 2px 0",
          fontSize: 12,
          color: "#6b7a8d",
          textAlign: isRtl ? "right" : "left",
        }}
      >
        {t("search_medical_rep_hint")}
      </p>

      {load && (
        <div className="loadinselect">
          <ReactLoading
            type="spinningBubbles"
            color="#9699c2"
            height={"7%"}
            width={"7%"}
          />
        </div>
      )}
    </div>
  );
}

export default MedicalRepsReportsSelect;
